import {Component, ElementRef, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {DateTimePeriodService} from "../../services/date-time-period.service";
import {TileDataService} from "../../services/tile_data.service";
import {Subject, Subscription} from "rxjs";
import {takeUntil} from "rxjs/operators";
import * as utils from "../../lib/utils";
import {isEmpty as _isEmpty} from "lodash-es";
import {SeriesStringParserService} from "../../services/series_string_parser.service";
import {deepCopy, refreshSubscription} from "../../lib/utils";
import {DateTimeInstanceService} from "../../services/date-time-instance.service";
import Quill from "quill";
import {ALLOWED_FONT_SIZES} from "../../shared/globals";
import {QuillEditorComponent} from "ngx-quill";

import {FormsModule} from "@angular/forms";
import {ChartDialogService} from "../../services/chart-dialog.service";

@Component({
    selector: 'paragraph',
    templateUrl: './paragraph.component.html',
    styleUrls: ["../../shared/styles/quill.scss"],
    imports: [
    QuillEditorComponent,
    FormsModule
],
    encapsulation: ViewEncapsulation.None
})
export class ParagraphComponent implements OnInit, OnDestroy {
    private readonly onDestroy = new Subject<void>();

    private $loadDisplayText: Subscription;

    @Input() config: { paragraph_body: any };
    @Input() show_header: boolean;

    paragraph: any = {};
    place_holder: string = '';

    constructor(public dateTimePeriodService: DateTimePeriodService,
                private dateInst: DateTimeInstanceService,
                public tileData: TileDataService,
                private stringParser: SeriesStringParserService,
                private elementRef: ElementRef,
                private chartDialogService:ChartDialogService) {
    }

    ngOnInit() {
        const ctrl = this;

        const Size: any = Quill.import('formats/size');
        Size.whitelist = ALLOWED_FONT_SIZES;
        Quill.register(Size, true);

        this.tileData.save_content.pipe(takeUntil(this.onDestroy)).subscribe(event => {
            this.setText(event.paragraph_body, this.dateInst.dtp);
            ctrl.paragraph.edit_text = event.paragraph_body;
        });
        this.dateInst.dateTimePeriodRefreshed$.pipe(takeUntil(this.onDestroy)).subscribe((dtp) => {
            this.setText(ctrl.paragraph.edit_text, dtp);
        });

        this.dateTimePeriodService.dtpInitialisedPromise.promise.then(() => {
            ctrl.paragraph.edit_text = ctrl.config.paragraph_body;
            this.setText(ctrl.paragraph.edit_text, this.dateInst.dtp);
        });
    }

    openChartDialog(event) {
       this.chartDialogService.openChartDialog(event.srcElement.id, this.dateInst.dtp);
    }

    setText(text, dtp) {
        const ctrl = this;
        ctrl.place_holder = '';
        ctrl.paragraph.display_text = null;

        if (!text || _isEmpty(text)) return;
        ctrl.place_holder = ctrl.stringParser.simpleParse(utils.deepCopy(text));

        this.$loadDisplayText = refreshSubscription(this.$loadDisplayText);
        this.$loadDisplayText = this.tileData.parseForSeriesValues(text, dtp).pipe(takeUntil(this.onDestroy)).subscribe((display) => {
            ctrl.paragraph.display_text = display;
            setTimeout(() => {
                const series_elements = this.elementRef.nativeElement.querySelectorAll('.series-element');
                series_elements.forEach(el => {
                    el.addEventListener('click', this.openChartDialog.bind(this));
                });
            });
        });
    }

    ngOnDestroy(): void {
        this.elementRef.nativeElement.querySelectorAll('.series_element').forEach(el => {
            el.removeEventListener('click', this.openChartDialog.bind(this));
        });
        this.onDestroy.next();
        this.onDestroy.unsubscribe();
    }
}
